// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3UN8d","colCheckbox":"styles_colCheckbox___YoJt"};